















import {Component, Mixins} from 'vue-property-decorator'
import OutsideView from "./OutsideView.vue"
import PolicyContent from '@/components/policy/PolicyContent.vue'
import TabBar from '@/components/lib/TabBar.vue'
import viewMetaMixin from '@/mixins/viewMetaMixin'
import {IOption} from '@/components/lib/models'

@Component({
  components: {
    OutsideView,
    TabBar,
    PolicyContent
  }
})
export default class Policy extends Mixins(viewMetaMixin) {

  get name(): string {
    return this.$storage.getters.getPlatformInfo().name;
  }

  get title(): string {
    let name = this.name;
    return this.$t('titles.policy') + (name ? (' ' + name) : '');
  }

  private policyTypes: string[] = [
    'privacy',
    'rules'
  ];

  get policies(): IOption<string>[] {
    return this.policyTypes.map((policy: string) => ({
      name: this.$options.filters?.capitalize(this.$t('policy.' + policy + '.title')),
      value: policy
    }));
  }

  get description(): string {
    let path = 'policy.' + this.choice + '.description';
    return this.$te(path) ? (this.$t(path) as string) : '';
  }

  private choice?: string = this.policies[0].value;

  mounted() {
    this.$store.dispatch('setCheckboxLabelColor', true);

    let hash = this.$route.hash?.replace(/#/g, '');
    if (this.policyTypes.indexOf(hash) !== -1) {
      this.choice = hash;
    }
  }

}
